import {FaCar, FaCopy} from "react-icons/fa";
import React from "react";
import {FaC} from "react-icons/fa6";
import {Toast, ToastContainer} from "react-bootstrap";


export const CopyAddress = (props) => {
    const {job} = props;
    const [show, setShow] = React.useState(false);
    return (
        <>
            <FaCopy style={{marginLeft: "10px", cursor: "pointer", color: "grey"}}
                    size={18}
                    onClick={(event) => {
                        event.stopPropagation()
                        setShow(true)
                        navigator.clipboard.writeText(job.full_address)
                    }}/>
            <ToastContainer className="p-3" position="bottom-center">
                <Toast show={show} onClose={() => setShow(false)} delay={1500} autohide>
                    <Toast.Body>Address copied!</Toast.Body>
                </Toast>
            </ToastContainer>
        </>
    )
}
